import { isLanguageSkill } from '../../app/common/skills';
import { HardSkillIcon } from '../assets/HardSkillIcon';
import { LanguageSkillIcon } from '../assets/LanguageSkillIcon';
import { SoftSkillIcon } from '../assets/SoftSkillIcon';

import type {
    HardSoftSkill,
    Skill,
    SkillWithIconColor,
    SoftSkill,
} from '../../../../shared/source/data-contract/skill';
import type { JSX } from 'react';

const isHardSkill = (skill: Skill): skill is HardSoftSkill => skill.skillType === 'hard';
const isSoftSkill = (skill: Skill): skill is SoftSkill => skill.skillType === 'soft';

export const getSkillIcon = (skill: SkillWithIconColor): JSX.Element | null => {
    if (isLanguageSkill(skill)) {
        return <LanguageSkillIcon color={skill.iconColor} />;
    }

    if (isSoftSkill(skill)) {
        return <SoftSkillIcon color={skill.iconColor} />;
    }

    if (isHardSkill(skill)) {
        return <HardSkillIcon color={skill.iconColor} />;
    }

    return null;
};
